<template>
  <span
    class="caption-bold"
    :style="tag.color_code ? { color: tag.color_code } : undefined"
  >
    {{ tag.label }}
  </span>
</template>

<script setup lang="ts">
import type { MarketingTag } from '../../../models/product'

defineProps<{ tag: MarketingTag }>()
</script>
